import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { NG_VALUE_ACCESSOR, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ReportCallDispositions } from '@ndt/report-output/shared/models/call-disposition-report-parameter';
import { Subject } from 'rxjs';
import { delay, takeUntil } from 'rxjs/operators';
import { ReportParameterComponent } from '../../report-parameter-list/report-parameter-component';
import { ReportParameterConfig } from '../../report-parameter-list/report-parameter.config';

@Component({
    providers: [{ multi: true, provide: NG_VALUE_ACCESSOR, useExisting: CallDispositionsReportParameterComponent }],
    selector: 'ndt-call-dispositions-report-parameter',
    templateUrl: './call-dispositions-report-parameter.component.html',
    standalone: false
})
export class CallDispositionsReportParameterComponent implements OnDestroy, AfterViewInit, ReportParameterComponent {
   form: UntypedFormGroup;

   private destroyed$ = new Subject<void>();

   config: ReportParameterConfig;

   callDispositions = Object.values(ReportCallDispositions);

   constructor() {
      this.form = new UntypedFormGroup({
         value: new UntypedFormControl(ReportCallDispositions.Both),
      });
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   ngAfterViewInit(): void {
      this.form.controls.isAskParameter?.valueChanges.pipe(delay(0), takeUntil(this.destroyed$)).subscribe(() => {
         this.form.controls.callDispositions?.updateValueAndValidity();
      });
   }

   callDispositionDisplayWith(option: ReportCallDispositions): string {
      return `${option ?? ''}`;
   }
}
